export default "__VITE_ASSET__BmYN5Cae__"